import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/success.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-943f1c02"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _createStaticVNode("<div class=\"payment-box\" data-v-943f1c02><img src=\"" + _imports_0 + "\" alt=\"\" data-v-943f1c02><p class=\"tip\" data-v-943f1c02>信息绑定成功</p><div class=\"\" style=\"margin-top:2rem;\" data-v-943f1c02><p class=\"info-content\" data-v-943f1c02> 您的订单信息可在个人中心里查看我们会尽快进行检测，检测结果出来后系统会自动把检测报告发到您的邮箱。 </p></div></div>", 1);
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("返回首页");
import { ref } from "vue";
import { NavBar, Icon, Button } from "vant";
import router from "../router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BindingSuccess',
    emits: ["cancel", "ok"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var loading = ref(false);
        var handleSubmit = function () {
            loading.value = true;
            setTimeout(function () {
                loading.value = false;
                router.push("/");
            }, 800);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "绑定成功",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_unref(Button), {
                        class: "submit-btn",
                        style: _normalizeStyle({ marginTop: '0.32rem', border: '2px solid #fff' }),
                        color: "#3DABA4",
                        block: "",
                        round: "",
                        onClick: handleSubmit
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_4
                        ]; }),
                        _: 1
                    }, 8, ["style"])
                ])
            ]));
        };
    }
});
